import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AdminShell } from '@/components/AdminShell';
import { Card, CardContent } from '@/components/ui/card';
import { FileText, BookOpen, Package, Users, ShoppingCart, Mail, MessageSquare } from 'lucide-react';
import api from '@/lib/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/admin/stats').then(res => setStats(res.data)).catch(console.error);
  }, []);

  const statCards = [
    { label: 'Published Essays', value: stats?.essays?.published || 0, total: stats?.essays?.total || 0, icon: FileText, href: '/admin/essays', color: 'gold' },
    { label: 'Frameworks', value: stats?.frameworks || 0, icon: BookOpen, href: '/admin/frameworks', color: 'sage' },
    { label: 'Waitlist Entries', value: stats?.waitlist || 0, icon: Users, href: '/admin/waitlist', color: 'champagne' },
    { label: 'Newsletter Subscribers', value: stats?.newsletter || 0, icon: Mail, href: '/admin/waitlist', color: 'silver' },
    { label: 'Orders', value: stats?.orders || 0, icon: ShoppingCart, href: '/admin/orders', color: 'gold' },
    { label: 'New Messages', value: stats?.new_contacts || 0, icon: MessageSquare, href: '/admin/contacts', color: 'rose' },
  ];

  return (
    <AdminShell title="Dashboard">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {statCards.map(card => {
          const Icon = card.icon;
          return (
            <Link key={card.label} to={card.href}>
              <Card className="bg-[hsl(var(--card))] border-[rgba(201,168,76,0.15)] hover:border-[rgba(201,168,76,0.3)] transition-colors duration-300">
                <CardContent className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <Icon className={`h-5 w-5 text-[hsl(var(--${card.color}))]`} />
                    <span className="font-['Inter'] text-[10px] font-medium uppercase tracking-[0.14em] text-[hsl(var(--silver))]">
                      {card.label}
                    </span>
                  </div>
                  <p className="font-['Cormorant_Garamond'] text-3xl font-bold text-[hsl(var(--foreground))]">
                    {card.value}
                  </p>
                  {card.total !== undefined && card.total !== card.value && (
                    <p className="font-['Inter'] text-xs text-[hsl(var(--muted-foreground))] mt-1">
                      {card.total} total
                    </p>
                  )}
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
    </AdminShell>
  );
}
